import { render, staticRenderFns } from "./uploaderRecom.vue?vue&type=template&id=4dd96c6a"
import script from "./uploaderRecom.vue?vue&type=script&lang=js"
export * from "./uploaderRecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports